import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    fabExtended: {
      zIndex: theme && theme.zIndex.drawer,
      boxShadow: '0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149)',
      backgroundColor: '#fff',
      textTransform: 'none',
      '&:hover': {
        boxShadow: '0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)',
        backgroundColor: '#fff'
      }
    },
    fabIcon: {
      width: '32px',
      height: '32px',
      fontSize: '32px'
    }
  });
